module.exports = __webpack_public_path__ + "static/media/Septic-Tank.f4a03fee.jpg";